export const sxGroupExpand = { mt: 0.5, borderRadius: "4px!important" };
